/** Scene keys of the shared core. Editions add their own HUD scene on top. */
export const SceneKey = {
  Preload: 'preload',
  Play: 'play',
} as const;
export type SceneKey = (typeof SceneKey)[keyof typeof SceneKey];
